export function isValidStringForParam(givenString) {
    var format = /[`#$%^&*()+={};':"<>?~]/;
    return format.test(givenString) === false;
}
